import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {PlatformQuery} from "@shared/models/platform-query/platform-query";
import {takeUntil, take, map, startWith} from "rxjs/operators";
import {PlatformQueryService} from "@core/services/platform-query.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MatCheckboxChange} from "@angular/material/checkbox";
import { Observable } from 'rxjs';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-spreadsheet-manage-entity-dialog',
  templateUrl: './spreadsheet-manage-entity-dialog.component.html',
  styleUrls: ['./spreadsheet-manage-entity-dialog.component.scss']
})

export class SpreadsheetManageEntityDialogComponent implements OnInit, IDialogView {

  filterId: string;
  filterTemplateId: string;
  endpointName: string;
  invalidateSubject = new InvalidateSubject();
  data: any;
  constructor(private platformQueryService: PlatformQueryService,
    private fuseSplashScreenService: FuseSplashScreenService,
     private formBuilder: FormBuilder) {
      this.filterTemplateId = "ed-entity-selector-filter";
      this.endpointName = "EntityChartApi";
   }
  onOkClicked(): boolean {
    return true;
  }
  onOtherButtonClicked?(): boolean {
    return true;
  }

  ngOnInit(): void {
    this.filterId = this.data.input['workbookId'];
  }

}
